import React, { useRef, useEffect } from "react";

const SIDEBAR_WIDTH = 56;

function LogsWelcomeTooltip({ visible, onDismiss }) {
  const cardRef = useRef(null);

  useEffect(() => {
    if (!visible) return;
    const handleClickOutside = (e) => {
      if (cardRef.current && !cardRef.current.contains(e.target)) onDismiss();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible, onDismiss]);

  if (!visible) return null;

  return (
    <>
      <style>
        {`@keyframes logsWelcomeIn {
          from { opacity: 0; transform: translateY(8px) translateX(-8px); }
          to { opacity: 1; transform: translateY(0) translateX(0); }
        }`}
      </style>
      <div
        ref={cardRef}
        role="dialog"
        aria-label="Admin logs tip"
        style={{
          position: "fixed",
          left: SIDEBAR_WIDTH + 14,
          bottom: 72,
          zIndex: 1001,
          animation: "logsWelcomeIn 0.25s ease-out",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            padding: "14px 20px 14px 18px",
            minWidth: "320px",
            maxWidth: "420px",
            background: "linear-gradient(120deg, rgba(30, 41, 59, 0.97) 0%, rgba(15, 23, 42, 0.97) 50%, rgba(30, 41, 59, 0.97) 100%)",
            border: "1px solid rgba(148, 163, 184, 0.22)",
            borderRadius: "14px",
            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(255,255,255,0.06) inset",
          }}
        >
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: "22px",
              boxShadow: "0 4px 12px rgba(99, 102, 241, 0.35)",
            }}
            aria-hidden
          >
            👽
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p
              style={{
                margin: 0,
                fontSize: "13px",
                color: "#e2e8f0",
                lineHeight: 1.5,
                fontWeight: 500,
              }}
            >
              Now you can see logs as well — only for admin activities. Happy Debugging 🛠️
            </p>
          </div>
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            style={{
              flexShrink: 0,
              width: "28px",
              height: "28px",
              borderRadius: "8px",
              border: "none",
              background: "rgba(148, 163, 184, 0.2)",
              color: "#94a3b8",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
              lineHeight: 1,
              transition: "background 0.15s, color 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(148, 163, 184, 0.35)";
              e.currentTarget.style.color = "#e2e8f0";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(148, 163, 184, 0.2)";
              e.currentTarget.style.color = "#94a3b8";
            }}
          >
            ×
          </button>
        </div>
        <div
          style={{
            position: "absolute",
            left: "-8px",
            bottom: "22px",
            width: 0,
            height: 0,
            borderTop: "8px solid transparent",
            borderBottom: "8px solid transparent",
            borderRight: "8px solid rgba(30, 41, 59, 0.97)",
          }}
        />
      </div>
    </>
  );
}

export default LogsWelcomeTooltip;
